import { render, staticRenderFns } from "./updatingDocument.popup-chunk.vue?vue&type=template&id=16606cc5&scoped=true"
import script from "./updatingDocument.popup-chunk.vue?vue&type=script&lang=ts"
export * from "./updatingDocument.popup-chunk.vue?vue&type=script&lang=ts"
import style0 from "./updatingDocument.popup-chunk.vue?vue&type=style&index=0&id=16606cc5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16606cc5",
  null
  
)

export default component.exports